'use strict';

const mmWidgets = require('./mm-widgets');

require('./section-handler-widget');
require('./show-error');
require('./show-progress-message');

mmWidgets.fn.domainSignupWidget = function (subscriptionModel, authenticationModel, subscriptionPlanModel) {
	if (!subscriptionModel || !authenticationModel) {
		throw new Error('invalid-args');
	}
	return mmWidgets.each(this, function () {
		const widget = this.sectionHandlerWidget(),
			registerDomain = async function (profile) {
				widget.showProgressMessage('Registering ' + profile.domain + ' with MindMup...');
				if (profile.provider === 'microsoft') {
					await subscriptionModel.registerMicrosoftOrganisation(profile.providerProfile.token);
				} else {
					await subscriptionModel.registerGoogleDomain(profile.providerProfile.token);
				}
			},
			showAccountInfo = function (goldAccountInfo) {
				const actions = goldAccountInfo && goldAccountInfo.subscription && goldAccountInfo.subscription.actions;
				subscriptionPlanModel.filterPlans(actions);

				if (goldAccountInfo && goldAccountInfo.subscription && goldAccountInfo.subscription.domain) {
					if (goldAccountInfo.purchaseComplete) {
						widget.showSection('subscriptionPurchased');
					} else if (goldAccountInfo.active) {
						widget.showSection('activeDomainSubscription');
					} else if (goldAccountInfo.subscription && goldAccountInfo.subscription.status === 'delinquent') {
						widget.showSection('delinquentDomainSubscription');
					} else if (goldAccountInfo.subscription &&  goldAccountInfo.subscription.actions && goldAccountInfo.subscription.actions.length && goldAccountInfo.subscription.actions.includes('BuyDomainSubscription')) {
						widget.showSection('buyDomainSubscription');
					} else if (goldAccountInfo.subscription && goldAccountInfo.license && goldAccountInfo.subscription.email === goldAccountInfo.license.email) {
						widget.showSection('purchaseInProgress');
					} else {
						widget.showSection('nonAdminForExpiredDomain');
					}
				} else {
					widget.showSection('activePersonalSubscription');
				}
			},
			showDetails = async () => {
				const goldAccountInfo = await subscriptionModel.getGoldAccountDetails(true);
				await showAccountInfo(goldAccountInfo);
			},
			domainCanBeRegistered = (profile) => !profile.license && profile.domain;

		authenticationModel.addEventListener('authenticatedProfile', async (profile) => {
			const providers = ['google', 'microsoft'];

			providers.forEach(provider => {
				if (profile.provider === provider) {
					widget.addClass('auth-' + provider);
				} else {
					widget.removeClass('auth-' + provider);
				}
			});
			try {
				if (profile && profile.license) {
					widget.showProgressMessage('Retrieving your account details, please wait...');
					await showDetails();
				} else if (domainCanBeRegistered(profile)) {
					await registerDomain(profile);
					await showDetails();
				} else {
					widget.showSection('nonDomainUser');
				}
			} catch (reason) {
				widget.showError(reason);
			}
			widget.trigger('authentication-profile-handler-complete');

		});
		['microsoft-blocked', 'google-blocked'].forEach(eventName => {
			authenticationModel.addEventListener(eventName, () => {
				widget.showSection(eventName);
			});
		});
		authenticationModel.addEventListener('authenticating', () => {
			widget.showProgressMessage('Authenticating, please wait...');
		});
		subscriptionModel.addEventListener('goldAccountInfo', (goldAccountInfo) => {
			if (goldAccountInfo.active) {
				showAccountInfo(goldAccountInfo);
			}
		});
	});
};

